import './RightSidebar.scss'
import {useFlintNotificationContext} from "../page_components/common/notifications/FlintNotificationContext";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import * as icons from "@fortawesome/free-solid-svg-icons";

export default function RightSidebar() {
    const {rightSidebar} = useFlintNotificationContext();
    return (
        <div className={"right-sidebar"}>
            <div className={"right-sidebar-header"}>
                {rightSidebar.get.title && (
                    <span className={"right-sidebar-title"}>{rightSidebar.get.title}</span>
                )}
                <button className={"right-sidebar-close"} onClick={rightSidebar.hide} aria-label="Close">
                    <FontAwesomeIcon icon={icons.faXmark}/>
                </button>
            </div>
            <div className={"right-sidebar-content"}>
                {rightSidebar?.get.children}
            </div>
        </div>
    );
}